// extracted by mini-css-extract-plugin
export default {"sectionTitle":"oiRuz","sectionImage":"ERAhR","link":"EV4hC","sectionSublist":"OpL6t","section":"Cx8s9","title":"gQQrH"};